var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActavivoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#paint0_linear_0_781)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9436 34.711H31.8224C32.4299 34.711 32.9676 35.1173 33.1444 35.709L33.6772 37.4992C33.9436 38.388 34.7477 38.9975 35.6589 38.9975H41.0316C41.5893 38.9975 42.1569 38.4312 41.9602 37.8979L34.3046 18.0985C33.3959 15.6328 31.083 14 28.5012 14C25.9195 14 23.6066 15.6328 22.6979 18.0985L15.0398 37.9005C14.8431 38.4312 15.4107 39 15.9684 39H21.1245C22.0406 39 22.8498 38.3829 23.1087 37.4865L23.6191 35.7217C23.7933 35.1224 24.3311 34.711 24.9436 34.711ZM31.073 25.0818L32.1112 28.5302C32.171 28.7308 32.0266 28.9314 31.8224 28.9289H28.2224C26.2979 28.9289 24.9187 26.8695 25.4788 24.9904L25.4963 24.9269C26.3328 22.1183 30.2291 22.2758 31.073 25.0818Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_781",
    x1: 60.458,
    y1: -2.20142,
    x2: 0.0551197,
    y2: -2.31165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    stopColor: "#D1D94E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#A6CA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313697,
    stopColor: "#7DBD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38553,
    stopColor: "#57B473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446853,
    stopColor: "#38AF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522134,
    stopColor: "#29AD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611094,
    stopColor: "#09AC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837037,
    stopColor: "#00A8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActavivoLogo);
export default __webpack_public_path__ + "static/media/Actavivo-Logo.c9d9ed5d65962a30a95fb5b7e3c80df1.svg";
export { ForwardRef as ReactComponent };